import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Couch = ({ color }: IconSvgProps) => (
  <IconSvg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5H18C19.1 5 20 5.9 20 7V9.15C18.84 9.57 18 10.67 18 11.97V14H6V11.97C6 10.66 5.16 9.56 4 9.15V7C4 5.9 4.9 5 6 5ZM19 12C19 10.9 19.9 10 21 10C22.1 10 23 10.9 23 12V17C23 18.1 22.1 19 21 19H3C1.9 19 1 18.1 1 17V12C1 10.9 1.9 10 3 10C4.1 10 5 10.9 5 12V15H19V12Z"
      fill="currentColor"
    />
  </IconSvg>
);

export default Couch;
